
export enum EntryValue {
    problem = "problem",
    suggestion = "suggestion",
    myfeedback = "myfeedback",
    myactivity = "myactivity",
}

export enum DetailViewType {
    all = "all",
    solutions = "solutions",
}

export enum ProductInfoExceptionValues {
    oldDotNetLogs = "oldDotNetNoLogs",
}

export const postTypes = [EntryValue.problem, EntryValue.suggestion] as const;

export const referrerNative: string = "native";                // e.g. native (i.e. was launched from VS/installer)

export enum Referrer {
    native = "native", // was launched from VS/installer
    cpp_unreal_engine = "cpp_unreal_engine", // coming from Unreal Engine VS tool marketplace link https://www.unrealengine.com/marketplace/en-US/product/visual-studio-integration-tool
    vs_devblog = "vs_devblog", // coming from https://devblogs.microsoft.com/visualstudio/
    vs_whatsnew = "vs_whatsnew", // coming from VS what's new page
}

export enum UrlParam {
    Entry = "entry",
    PreviewFeaturesEnabled = "preview2",
    ReferrerUserId = "refUserId",
    Referrer = "ref",                   // one of the `enum Referrer` values
    ReferrerTimestamp = "refTime",      // Used to ensure we don't show message for very long if user bookmarks link to a ticket when launched via VS
    DetailViewType = "viewtype",
    /** Flag to enable reporting for any space. Used to enable reporting for IT Admins for VS before VS is installed */
    BeforeInstall = "beforeInstall",
    ProvideMoreInfo = "moreInfo",
    Port = "port",
    Fsid = "fsid",
    ErrorId = "errorId",
    SpaceId = "space",
    FeedbackScopeFilter = "scope",
    FeedbackStateGroupFilter = "stateGroup",
    FeedbackAreaFilter = "area",
    FeedbackTypeFilter = "ftype",
    FeedbackTimeFilter = "fTime",
    Sort = "sort",
    PageNumber = "page",
    PageSize = "pageSize",
    SearchText = "q",

    /** Azure Subscription ID - captured as a tag by Azure DevBox and similar spaces */
    AzureSubscriptionId = "sub_id",

    /** Azure Resource ID (for DevBox and App Services team) */
    AzureResourceId = "res_id",

    /** Azure App Services */
    SessionId = "session_id",
    AzureResourceType = "res_type",
    OS = "os",
    Sku = "sku",
    PublishType = "publish_type",

    /** Azure test run ID (to be used by Load testing team) */
    AzureTestRunId = "test_run_id",

    /// Azure DevOps
    AdoVersion = "version",
    AdoAccountId = "vsts_account_id",
    AdoAccountName = "vsts_account_name",
    AdoProjectId = "vsts_project_id",
    AdoSubmittedFrom = "vsts_submitted_from",

    // Exception for including required product info in post
    ProductInfoException = "productInfoException",
}

/** Parameters to turn to tags on backend */
export const tagParams = [
    UrlParam.AdoVersion,
    UrlParam.AdoAccountId,
    UrlParam.AdoAccountName,
    UrlParam.AdoProjectId,
    UrlParam.AdoSubmittedFrom,

    UrlParam.AzureSubscriptionId,
    UrlParam.AzureResourceId,
    UrlParam.AzureResourceType,
    UrlParam.SessionId,
    UrlParam.OS,
    UrlParam.Sku,
    UrlParam.PublishType,

    UrlParam.Referrer,
];

export const postId: string = "postId";
export const title: string = "title";
export const spaceSlug: string = "spaceSlug"; // for urls like "/devbox" "/dotnet" or "/VisualStudio"; not an actual slug from outer space
export const comments: string = "comments"; // for urls like site.com/devbox/comments/...

export function convertIncorrectEntry(entry: string): (EntryValue | null) {
    if (!entry) {
        return null;
    }

    if (entry === "report") { // value sent by Installer
        return EntryValue.problem;
    }

    if (entry === "suggest") { // value sent by Installer
        return EntryValue.suggestion;
    }

    return entry as EntryValue;
}

export const hashPrefixTicket = "T";
export const hashPrefixTicketPinnedItems = "TPIN";
export const hashPrefixNode = "N";
export const hashPrefixNodeDirect = "ND";

export const hashForNode = (nodeId: string | number, prefix: string): string => `${prefix}-${hashPrefixNode}${nodeId}`;
export const hashForNodeDirect = (nodeId: string | number): string => `${hashPrefixTicket}-${hashPrefixNodeDirect}${nodeId}`;
export const isPrefixForPinnedSection = (prefix: string): boolean => prefix && prefix.startsWith(hashPrefixTicketPinnedItems);
